export default "__VITE_ASSET__lWbuZjit__"